<div class="op-overlay" id="openPalmOrderPayment" (click)="handleOffcanvasClose()" tabindex="-1"
	aria-labelledby="orderPayTitle" aria-modal="true" role="dialog">

	<div class="order-pay" (click)="$event.stopPropagation()">

	<div class="op-header">
		<div class="op-head">
			<span class="op-eyebrow">Checkout</span>
			<h1 id="orderPayTitle">Order Summary</h1>
		</div>
		<button type="button" (click)="handleOffcanvasClose()" class="op-close" aria-label="Close">
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
				<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
			</svg>
		</button>
	</div>

	<div class="op-body">

		<div class="op-card">
			<div class="op-product">
				<div class="op-product-icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
						<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9l2 2 4-4"
							stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>
				<div class="op-product-info">
					<span class="op-label">Service</span>
					<p class="op-name">{{ pujaData?.productName }}</p>
				</div>
			</div>

			<div class="op-rows">
				<div class="op-row">
					<span>Service price</span>
					<span>{{ gS.currencySign }} {{ orderPrice }}</span>
				</div>

				<ng-container *ngIf="balanceLoaded && walletApplied > 0">
					<div class="op-row op-row-credit">
						<span>Wallet balance applied</span>
						<span>&minus; {{ gS.currencySign }} {{ walletApplied }}</span>
					</div>
				</ng-container>

				<ng-container *ngIf="balanceLoaded && needsTopUp">
					<div class="op-row">
						<span>To pay</span>
						<span>{{ gS.currencySign }} {{ shortfall }}</span>
					</div>
					<div class="op-row" *ngIf="topUpGst > 0">
						<span>GST (18%)</span>
						<span>{{ gS.currencySign }} {{ topUpGst }}</span>
					</div>
				</ng-container>

				<div class="op-row op-row-muted" *ngIf="balanceLoaded && !needsTopUp">
					<span>Taxes &amp; fees</span>
					<span>Included</span>
				</div>
			</div>

			<div class="op-total">
				<span>{{ balanceLoaded && needsTopUp ? 'Payable now' : 'Total payable' }}</span>
				<span class="op-total-amt">
					{{ gS.currencySign }} {{ balanceLoaded && needsTopUp ? payableNow : orderPrice }}
				</span>
			</div>

			<p class="op-hint" *ngIf="balanceLoaded && needsTopUp && walletApplied > 0">
				Your wallet covers {{ gS.currencySign }}{{ walletApplied }} of this order. Pay the balance below to
				confirm.
			</p>
		</div>

		<ul class="op-trust">
			<li>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
					<path d="M12 2l7 3v6c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V5l7-3z" stroke="currentColor"
						stroke-width="1.6" stroke-linejoin="round" />
					<path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
						stroke-linejoin="round" />
				</svg>
				100% Secure &amp; encrypted payment
			</li>
			<li>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
					<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
					<path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
						stroke-linejoin="round" />
				</svg>
				Handled by verified CAs &amp; lawyers
			</li>
		</ul>

		<div class="op-footer">
			<button type="button" (click)="payNow()" class="op-confirm" [disabled]="!balanceLoaded || isProcessing">
				<ng-container *ngIf="isProcessing">Processing&hellip;</ng-container>
				<ng-container *ngIf="!isProcessing">
					<ng-container *ngIf="needsTopUp">
						Pay {{ gS.currencySign }} {{ payableNow }} securely
					</ng-container>
					<ng-container *ngIf="!needsTopUp">
						Confirm &amp; Pay {{ gS.currencySign }} {{ orderPrice }}
					</ng-container>
				</ng-container>
			</button>
			<p class="op-note">By confirming, you agree to our Terms &amp; Refund Policy.</p>
		</div>

	</div>
	</div>
</div>
